module.exports = __webpack_public_path__ + "media/matrum.261619c7.mp4";